import { cn } from '@cobliteam/ui/utils';
import LoadingImg from './assets/loading.webp';
import Logo from './assets/logo.svg?react';

type LoadingPageProps = {
  message?: string;
  showLogo?: boolean;
  /**
   * Alturas suportadas:
   * - 'screen' (default): `h-screen` — full-page loader (usado no boot, PrivateRouterProvider).
   * - 'fill': `h-full` — preenche o container pai (usado como Suspense fallback dentro de AppLayout,
   *   evita CLS quando swap para conteúdo com altura diferente).
   */
  height?: 'screen' | 'fill';
};

function LoadingPage({ message, showLogo = false, height = 'screen' }: LoadingPageProps) {
  return (
    <div data-testid='loading-page' key='loading-page' className={height === 'fill' ? 'h-full' : undefined}>
      {showLogo && (
        <div className='absolute top-0 left-0 p-4'>
          <Logo />
        </div>
      )}
      <div className={cn('flex flex-col items-center justify-center', height === 'fill' ? 'h-full' : 'h-screen')}>
        <div className='flex items-center justify-center'>
          <img src={LoadingImg} width={75} height={75} />
        </div>
        <div className='flex items-center gap-2 text-gray-11 text-sm'>{message || 'Carregando dados da página...'}</div>
      </div>
    </div>
  );
}

export default LoadingPage;
